(() => {
  function initQuantitySync(form) {
    const selector = form.querySelector(".form-quantity-selector input");
    const quantityField = form.querySelector(
      ".form-quantity-field .ginput_quantity"
    );
    if (!selector || !quantityField) return;

    quantityField.value = selector.value;
    const event = new Event("change", { bubbles: true });
    quantityField.dispatchEvent(event);

    if (!selector._quantityListener) {
      selector.addEventListener("input", () => {
        quantityField.value = selector.value;
        const event = new Event("change", { bubbles: true });
        quantityField.dispatchEvent(event);
      });
      selector._quantityListener = true;
    }
  }

  function stripValue(val) {
    return val.replace(/[^0-9.]/g, "");
  }

  function initSuggestedAmountSync(form) {
    const suggestedSelector = "form-suggested-amount";
    const amountSelector = "form-amount-field";
    const containers = form.querySelectorAll(
      `.${suggestedSelector}, .${amountSelector}`
    );

    let suggestedContainer = null;

    containers.forEach((container) => {
      if (container.classList.contains(suggestedSelector)) {
        suggestedContainer = container;
      } else if (container.classList.contains(amountSelector)) {
        if (!suggestedContainer) return;

        const amountInput = container.querySelector('input[type="text"]');
        const suggestedRadios = suggestedContainer.querySelectorAll(
          'input[type="radio"]'
        );

        if (!amountInput || suggestedRadios.length === 0) return;

        if (suggestedContainer && !suggestedContainer._delegatedListener) {
          suggestedContainer.addEventListener("input", (e) => {
            const radio = e.target;
            if (radio.type === "radio" && radio.checked) {
              amountInput.value = radio.value;
              const event = new Event("change", { bubbles: true });
              amountInput.dispatchEvent(event);
              suggestedRadios.forEach((other) => {
                if (other !== radio) other.checked = false;
              });
            }
          });
          suggestedContainer._delegatedListener = true;
        }

        if (!amountInput._amountFieldListener) {
          amountInput.addEventListener("input", () => {
            let matched = false;
            const inputVal = stripValue(amountInput.value);
            suggestedRadios.forEach((radio) => {
              if (stripValue(radio.value) === inputVal) {
                radio.checked = true;
                matched = true;
              } else {
                radio.checked = false;
              }
            });
            if (!matched) {
              suggestedRadios.forEach((radio) => {
                radio.checked = false;
              });
            }
          });
          amountInput._amountFieldListener = true;
        }

        suggestedContainer = null;
      }
    });
  }

  function initAllForms() {
    document.querySelectorAll("form").forEach((form) => {
      initSuggestedAmountSync(form);
      initQuantitySync(form);
    });
  }

  document.addEventListener("DOMContentLoaded", initAllForms);
  document.addEventListener("gform/post_render", initAllForms);
  document.addEventListener("gform_page_loaded", initAllForms);
})();
